import { useState, useEffect, useContext, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { Switch } from '@headlessui/react'
import { setTrainingPeaksIntegrationActive } from 'redux/slices/user'
import loadingSpinner from 'media/loading.svg'
// import finalSurgeLogo from 'media/integrations/final_surge/Final_Surge_Logo.png'
import trainingPeaksLogo from 'media/integrations/training_peaks/TP_Preferred_Vertical Logo-Blue-Navy-2X.png'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'

export default function ManageIntegrationsView() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const [searchParams] = useSearchParams()

    const hasProcessedTokenExchange = useRef(false)

    const { ShowModal } = useContext(ModalContext)

    const userId = useSelector((state) => state.user.id)
    const organizationId = useSelector((state) => state.user.organizationId)
    // const isFinalSurgeIntegrationActive = useSelector((state) => state.user.isFinalSurgeIntegrationActive)
    const isTrainingPeaksIntegrationActive = useSelector((state) => state.user.isTrainingPeaksIntegrationActive)

    // const [finalSurgeIntegrationCardLoading, setFinalSurgeIntegrationCardLoading] = useState(false)
    const [trainingPeaksIntegrationCardLoading, setTrainingPeaksIntegrationCardLoading] = useState(false)

    // Final Surge functions

    /*
    const OnToggleFinalSurgeIntegration = async () => {
        if (isFinalSurgeIntegrationActive === false){ 
            RedirectToFinalSurgeAuthURL()
        }
        
        if (isFinalSurgeIntegrationActive === true) { 
            ShowFinalSurgeIntegrationDeauthWarningModal()
        }
    }

    const RedirectToFinalSurgeAuthURL = async () => {

        // If already loading, don't allow another request
        if (finalSurgeIntegrationCardLoading === true) return

        setFinalSurgeIntegrationCardLoading(true)

        const jsonBody = {
            userId: userId, // Used for authorizer
            redirect_uri: window.location.origin + '/settings/integrations'
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('PROGRAM', 'GET', '/final_surge_auth_url', jsonBody);

        // console.log(result)

        if (result.data.status === 'failure') {
            setFinalSurgeIntegrationCardLoading(false)
            console.error(result)
            return
        }

        var authURL = result.data.authURL;

        window.location.href = authURL;

        setFinalSurgeIntegrationCardLoading(false)
    }

    const CallFinalSurgeTokenExchangeAPI = async (code) => {

        setFinalSurgeIntegrationCardLoading(true)

        const jsonBody = {
            userId: userId, // Used for authorizer
            code: code
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('PROGRAM', 'POST', '/final_surge_token_exchange', jsonBody);

        // console.log(result)
        
        setFinalSurgeIntegrationCardLoading(false)

        // window.location.reload()

    }

    const ShowFinalSurgeIntegrationDeauthWarningModal = () => {

        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'Disconnect TrainingPeaks Integration?',
            bodyText: [
                'Are you sure you want to disconnect your TrainingPeaks coach account from your Kinesis coach account?',
                'Future data from training peaks will no longer be synced to your Kinesis calendar.',
            ],
            buttonText: 'Disconnect',
            buttonAction: async () => { 
                // await DeauthTrainingPeaksIntegration() // TODO: Implement
            }
        }

        ShowModal(modalData)

    }
    */

    // TrainingPeaks functions

    const OnToggleTrainingPeaksIntegration = async () => {
        if (isTrainingPeaksIntegrationActive === false){ 
            RedirectToTrainingPeaksAuthURL()
        }
        
        if (isTrainingPeaksIntegrationActive === true) { 
            ShowTrainingPeaksIntegrationDeauthWarningModal()
        }
    }

    const RedirectToTrainingPeaksAuthURL = async () => {

        // If already loading, don't allow another request
        if (trainingPeaksIntegrationCardLoading === true) return

        setTrainingPeaksIntegrationCardLoading(true)

        const jsonBody = {
            userId: userId, // Used for authorizer
            redirect_uri: window.location.origin + '/settings/integrations'
        }

        const result = await WhichWeightAPI('CORE', 'GET', '/training_peaks_auth_url', jsonBody);

        // console.log(result)

        if (result.data.status === 'failure') {
            setTrainingPeaksIntegrationCardLoading(false)
            console.error(result)
            return
        }

        var authURL = result.data.authURL;

        window.location.href = authURL;

        setTrainingPeaksIntegrationCardLoading(false)
    }

    const CallTrainingPeaksTokenExchangeAPI = async (code) => {

        setTrainingPeaksIntegrationCardLoading(true)

        const jsonBody = {
            userId: userId, // Used for authorizer
            code: code,
            redirect_uri: window.location.origin + '/settings/integrations'
        }

        const result = await WhichWeightAPI('CORE', 'POST', '/training_peaks_token_exchange', jsonBody);

        setTrainingPeaksIntegrationCardLoading(false)

        window.location.reload()

    }

    const ShowTrainingPeaksIntegrationDeauthWarningModal = () => {

        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'Disconnect TrainingPeaks Integration?',
            bodyText: [
                'Are you sure you want to disconnect your TrainingPeaks coach account from your Kinesis coach account?',
                'Future data from training peaks will no longer be synced to your Kinesis calendar.',
            ],
            buttonText: 'Disconnect',
            buttonAction: async () => { 
                await DeauthTrainingPeaksIntegration()
            }
        }

        ShowModal(modalData)

    }

    const DeauthTrainingPeaksIntegration = async () => {

        const jsonBody = {
            userId: userId,
            organizationId: organizationId
        }

        const result = await WhichWeightAPI('CORE', 'POST', '/training_peaks_deauth', jsonBody);

        // console.log(result)

        if (result.data.status === 'success') {
            dispatch(setTrainingPeaksIntegrationActive(false))
            window.location.reload()
        }
    }

    // Handle token exchange when redirected back from TrainingPeaks

    useEffect(() => {
        const code = searchParams.get('code')
        
        if (code && code.length > 0 && !hasProcessedTokenExchange.current) {

            hasProcessedTokenExchange.current = true
            CallTrainingPeaksTokenExchangeAPI(code)
            navigate(location.pathname, { replace: true }) // Clear the code from URL

        } else if (code === '' && !hasProcessedTokenExchange.current) {

            console.error('No code found in URL')
            hasProcessedTokenExchange.current = true // Handle case where code param exists but is empty
            // ShowTokenExchangeStatusModal('failure')
            navigate(location.pathname, { replace: true }) // Clear the code from URL
            window.location.reload()
        }
    }, [searchParams, navigate, location.pathname])

    return (
        <ScreenFrame>
            <div className='max-w-4xl mx-auto space-y-4'>
                <div className='flex items-center space-y-1 gap-x-2 pb-2'>
                    <h1 className="text-2xl font-semibold text-gray-900 tracking-tight pt-2 flex-grow">
                        Integrations
                    </h1>
                </div>

                {/* Final Surge integration */}

                {/*
                <ContentFrame>
                    <div 
                        className="w-full flex items-center px-8 py-6 gap-x-8 cursor-pointer hover:bg-gray-50 transition-colors"
                        onClick={OnToggleFinalSurgeIntegration}
                    >
                        <img src={finalSurgeLogo} alt="Final Surge" className="w-40 mt-1" />

                        <div className="flex-grow">
                            <div className="text-lg font-semibold">Connect Final Surge</div>
                            <div className="text-sm text-gray-500">
                                Sync athletes and workouts between Final Surge and Kinesis
                            </div>
                        </div>

                        {finalSurgeIntegrationCardLoading === false &&
                            <Switch
                                checked={isFinalSurgeIntegrationActive}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                    ${isFinalSurgeIntegrationActive ? 'bg-orange-400' : 'bg-gray-200'}
                                `}
                            >
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${isFinalSurgeIntegrationActive ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>
                        }

                        {finalSurgeIntegrationCardLoading === true && 
                            <img src={loadingSpinner} alt="Loading" className="w-8 h-8 spinner mr-1" />
                        }
                    </div>
                </ContentFrame>
                */}

                {/* TrainingPeaks integration */}

                <ContentFrame>
                    <div 
                        className="w-full flex items-center px-8 py-6 gap-x-8 cursor-pointer hover:bg-gray-50 transition-colors"
                        onClick={OnToggleTrainingPeaksIntegration}
                    >
                        <img src={trainingPeaksLogo} alt="TrainingPeaks" className="w-40 mb-0.5" />

                        <div className="flex-grow">
                            <div className="text-lg font-semibold">Connect TrainingPeaks</div>
                            <div className="text-sm text-gray-500">
                                Sync athletes and workouts between TrainingPeaks and Kinesis
                            </div>
                        </div>

                        {trainingPeaksIntegrationCardLoading === false &&
                            <Switch
                                checked={isTrainingPeaksIntegrationActive}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                    ${isTrainingPeaksIntegrationActive ? 'bg-orange-400' : 'bg-gray-200'}
                                `}
                            >
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${isTrainingPeaksIntegrationActive ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>
                        }

                        {trainingPeaksIntegrationCardLoading === true && 
                            <img src={loadingSpinner} alt="Loading" className="w-8 h-8 spinner mr-1" />
                        }
                    </div>
                </ContentFrame>
            </div>
        </ScreenFrame>
    )
}